import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/FooterLegal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/FooterSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/GoogleTagManClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/BookConsultationNow.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/Drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KarePediaLogo"] */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/KarePediaLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/NavCategoryDesktop.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/NotificationMob.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/NotificationSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/SearchMob.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/NavBar/compoents/SearchPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/shehin/backup-07-08-26/components/TostMessageCompoent.tsx");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":\"normal\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/cgcBlog/cgcLogo.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/footer/facebook-app-symbol.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/footer/instagram.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/footer/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/footer/twitter.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/footer/youtube.svg");
;
import(/* webpackMode: "eager" */ "/home/shehin/backup-07-08-26/public/paBlog/pa-logo.png");
